import { get as _get, merge as _merge } from 'lodash';

import {
  CoverageChangeRequest,
  InitialCoverageChangeRequestState
} from '../models/coverage-change.model';
import { CoverageChangeActionsUnion, CoverageChangeActionTypes } from './coverage-change.actions';

export const initialState: CoverageChangeRequest = new InitialCoverageChangeRequestState();

export function reducer(
  state = initialState,
  action: CoverageChangeActionsUnion
): CoverageChangeRequest {
  switch (action.type) {
    case CoverageChangeActionTypes.COVERAGE_CHANGE_COVERAGES_LIMITS_REQUEST_SUCCESS: {
      return { ...state, autoCoverages: _get(action, 'payload') };
    }
    case CoverageChangeActionTypes.SET_COVERAGE_CHANGE_SELECTED_LIMITS_REQUEST: {
      return { ...state, selectedCoverages: _get(action, 'payload') };
    }

    case CoverageChangeActionTypes.COVERAGE_CHANGE_QUOTE_REQUEST_SUCCESS: {
      return { ...state, quote: _get(action, 'payload') };
    }

    case CoverageChangeActionTypes.COVERAGE_CHANGE_SET_REQUEST_TYPE: {
      return { ...state, requestType: _get(action, 'payload') };
    }

    default: {
      return state;
    }
  }
}
